/** BookingStatusChips — the status filter at card breakpoints, where there is
 *  room to show every option at once. The desktop equivalent is
 *  `BookingStatusSelect`. */
import { STATUS_OPTIONS, type StatusValue } from './bookingFilterOptions';

export function BookingStatusChips({
  status,
  onStatusChange,
}: {
  status: StatusValue;
  onStatusChange: (v: StatusValue) => void;
}) {
  return (
    <div
      role="group"
      aria-label="Filter by status"
      className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1"
    >
      {STATUS_OPTIONS.map((o) => {
        const active = status === o.value;
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={active}
            onClick={() => onStatusChange(o.value)}
            className={`whitespace-nowrap rounded-full border px-4 py-1.5 text-sm font-medium transition ${
              active
                ? 'border-moss-600 bg-moss-600 text-white'
                : 'border-stone-200 bg-white text-stone-600 hover:border-stone-300 dark:border-stone-700 dark:bg-[#1a1f1c] dark:text-stone-300'
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
